<template>
    <v-app>
        <v-content>
            <v-container fluid fill-height>
                <v-layout justify-center align-center>
                    <v-flex text-xs-center justify-center>
                        <v-form v-model="valid" @submit.prevent="login">
                            <v-card width="30em" class="mx-auto">
                                <v-card-title>
                                    <div class="login-form-card-body">
                                        <div v-if="spaceMetadata">
                                            <div class="form-title">
                                                <img :src="spaceMetadata.icon" :alt="spaceMetadata.name"
                                                     class="space-icon">
                                                <span class="title">{{$store.state.spaceMetadata.name}}</span>
                                            </div>
                                            <v-text-field
                                                    autofocus
                                                    color="accent"
                                                    v-model="username"
                                                    label="Username"
                                                    required
                                            ></v-text-field>
                                            <v-text-field
                                                    color="accent"
                                                    v-model="password"
                                                    label="Password"
                                                    required
                                                    type="password"
                                            ></v-text-field>
                                        </div>
                                        <div v-else class="form-loading">
                                            <font-awesome-icon :icon="['fal', 'spinner-third']" spin size="2x"/>
                                        </div>
                                    </div>
                                </v-card-title>
                                <v-card-actions>
                                    <div class="actions-container">
                                        <v-btn color="accent" dark v-bind:disabled="!spaceMetadata" type="submit"
                                               v-bind:loading="loadingState === LOADING_STARTED">
                                            <span v-if="loadingState !== LOADING_COMPLETED_FAILURE">
                                                Login
                                            </span>
                                            <span v-if="loadingState === LOADING_COMPLETED_FAILURE">
                                                Try Again
                                            </span>
                                        </v-btn>
                                    </div>
                                </v-card-actions>
                            </v-card>
                        </v-form>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
    import {
        LOGIN_COOKIE_KEY,
        LOAD_SPACE_METADATA,
        LOAD_CURRENT_USER,
        LOAD_SPACE_CONTENT_TYPES,
        LOAD_SPACE_LOCALIZATIONS,
        LOAD_SPACE_ASSET_CONTENT_TYPE,
        SET_SESSION_TOKEN,
        LOADING_PRISTINE,
        LOADING_STARTED,
        LOADING_COMPLETED_SUCCESS,
        LOADING_COMPLETED_FAILURE,
        LOAD_SPACE_PROPERTIES,
    } from "../services/constants"
    import BaseLoadingComponent from './BaseLoading'
    import http from '../services/axios'

    export default {
        name: 'login',
        extends: BaseLoadingComponent,
        data: function () {
            return {
                valid: false,
                username: '',
                // usernameRules: [
                //     v => !!v || 'Name is required',
                //     v => v.length <= 10 || 'Name must be less than 10 characters'
                // ],
                password: '',
                // passwordRules: [
                //     v => !!v || 'E-mail is required',
                //     v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
                // ]
                loadingState: LOADING_PRISTINE,
            }
        },
        computed: {
            spaceMetadata: function () {
                return this.$store.state.spaceMetadata
            }
        },
        methods: {
            login: async function () {
                this.loadingState = LOADING_STARTED
                const loginData = {
                    username: this.username,
                    password: this.password,
                }
                try {
                    const response = await http.post(`api/management/spaces/${this.$store.state.spaceMetadata.id}/sessions`, loginData)
                    if (response.data.success) {
                        this.loadingState = LOADING_COMPLETED_SUCCESS
                        this.$store.commit(SET_SESSION_TOKEN, {
                            [LOGIN_COOKIE_KEY]: response.data.token,
                        });

                        const proms0 = []
                        proms0.push(this.$store.dispatch(LOAD_CURRENT_USER))
                        proms0.push(this.$store.dispatch(LOAD_SPACE_PROPERTIES))
                        await Promise.all(proms0)
                        this.$store.dispatch(LOAD_SPACE_CONTENT_TYPES)
                        this.$store.dispatch(LOAD_SPACE_ASSET_CONTENT_TYPE)
                        this.$store.dispatch(LOAD_SPACE_LOCALIZATIONS)
                        this.$router.push(`${this.$router.currentRoute.path}/u`)
                    } else {
                        this.loadingState = LOADING_COMPLETED_FAILURE
                    }

                } catch (err) {
                    this.loadingState = LOADING_COMPLETED_FAILURE
                    console.log(err)

                }
            }
        },
        created: function () {
            return this.$store.dispatch(LOAD_SPACE_METADATA, {
                spaceIdentifier: this.$route.params.spaceIdentifier
            })
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .login-form-card-body {
        width: 100%;
    }

    img.space-icon {
        $img-size: 64px;
        max-height: $img-size;
        max-width: $img-size;
        vertical-align: middle;
        margin: 0 1em 0 0;
    }

    .form-title {
        display: flex;
        align-items: center;
        margin: 0 0 1em 0;
        color: #616161;
    }

    .form-loading {
        display: flex;
        justify-content: flex-end;
    }

    .right-icon {
        margin: 0 0 0 1em;
    }

    .actions-container {
        width: 100%;
        padding: 0 0 1em 0;
        display: flex;
        justify-content: center;
    }
</style>
